import React, { useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Box, Link, Stack, TextField } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '../design-system';
import { useAuth } from '../context/AuthContext';
import AuthLayout, { AuthPasswordField } from '../components/auth/AuthLayout';

export { default as AuthLayout } from '../components/auth/AuthLayout';

export default function LoginPageModern({ onToggleTheme }) {
  const { t } = useTranslation('auth');
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signIn({ email: email.trim(), password });
      navigate(location.state?.from?.pathname || '/dashboard', { replace: true });
    } catch (signInError) {
      setError(signInError.message || t('errors.login'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title={t('loginTitle')} subtitle={t('loginSubtitle')} onToggleTheme={onToggleTheme}>
      {error && <Alert severity="error" role="alert">{error}</Alert>}
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%' }}>
        <Stack spacing={2.5} sx={{ width: '100%', mt: error ? 2.5 : 0 }}>
          <TextField label={t('email')} type="email" value={email} onChange={(event) => setEmail(event.target.value)}
            autoComplete="email" required fullWidth autoFocus inputProps={{ 'aria-label': 'Email' }}
          />
          <AuthPasswordField label={t('password')} value={password}
            onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required fullWidth
            inputProps={{ 'aria-label': t('password') }} />
          <Link className="auth-text-link auth-forgot" component={RouterLink} to="/forgot-password" underline="hover">
            {t('forgotPassword')}
          </Link>
          <Button className="auth-submit" type="submit" variant="contained" size="large" fullWidth endIcon={<ArrowForward />}
            disabled={submitting} aria-busy={submitting}>
            {submitting ? t('signingIn') : t('loginTab')}
          </Button>
          <p className="auth-account-prompt">
            {t('noAccount')}{' '}<Link className="auth-text-link" component={RouterLink} to="/register">{t('createAccountLink')}</Link>
          </p>
        </Stack>
      </Box>
    </AuthLayout>
  );
}
